// Author: Sunil Jain [Date: 2025-03-25 Tue 01:21 PM EDT]
// src/contexts/RegistrationContext.js

import React, { createContext, useState, useContext } from 'react';

// Define the initial state structure (matches your form fields)
const initialRegistrationState = {
    firstName: '', lastName: '', dateOfBirth: '',
    email: '', password: '', confirmPassword: '',
    consent: false, mrn: '',
    invitationToken: null,
    tenantId: null,
};

// Create the context
const RegistrationContext = createContext({
    registrationData: initialRegistrationState,
    setRegistrationData: () => {}, // Placeholder function
});

// Create a provider component
export const RegistrationProvider = ({ children }) => {
    const [registrationData, setRegistrationData] = useState(initialRegistrationState);

    return (
        <RegistrationContext.Provider value={{ registrationData, setRegistrationData }}>
            {children}
        </RegistrationContext.Provider>
    );
};

// Custom hook to easily use the context
export const useRegistration = () => useContext(RegistrationContext);